import { CommonModule } from "@angular/common";
import { Component, inject, input, InputSignal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { RouterLink } from "@angular/router";
import { EvCore } from "ev-core";
import { MiniInfoCardRealEstatePropertiesComponent } from "src/app/ev-map/commercial-map/commercial-sale/commercial-sale-infocard/components/mini-infocard-realestate-properties/mini-infocard-realestate-properties.component";
import { MiniInfocardEstateSale } from "src/models/estate/mini-infocard-estate.model";
import { ResourceService } from "src/services/resources/resource.service";
import { EvAuthorizationService } from "src/util/auth0/ev-auth.service";
import { EVServiceType } from "src/util/auth0/models/evServiceType.enum";

@Component({
    selector: "estate-sale-infocard-properties",
    imports: [EvCore, CommonModule, RouterLink, MiniInfoCardRealEstatePropertiesComponent],
    templateUrl: "./estate-sale-infocard-properties.component.html",
    styleUrl: "./estate-sale-infocard-properties.component.scss",
})
export class EstateSaleInfocardPropertiesComponent {
    selectedSale: InputSignal<MiniInfocardEstateSale> = input.required();
    private readonly resourceService = inject(ResourceService);
    private readonly authService = inject(EvAuthorizationService);

    showUncertainPriceDescription: boolean = false;
    canCreateAppraisal = toSignal(this.authService.hasPermission(EVServiceType.Appraisal_Realtor));
    hasHideStartNewAppraisalButton = toSignal(this.authService.hasPermission(EVServiceType.Evweb_HideStartNewAppraisalButton));
    hasValueAssistant = toSignal(this.authService.hasPermission(EVServiceType.EvWeb_ValueAssistant));
    saleStatus = SaleStatus;

    showPriceDescription = () => {
        if (this.selectedSale().uncertainPrice) {
            this.showUncertainPriceDescription = true;
        }
    };

    splitSaleInfoText(text: string, takeLeft: boolean = true): string {
        let result = "";

        const regexp = /([\D]+)([\d|\.]+)/im;
        const matches = regexp.exec(text);
        if (matches != null) {
            if (takeLeft) {
                result = matches[1];
            } else {
                result = matches[2];
            }
        } else {
            result = "";
        }

        return result;
    }

    getProspect(saleId: number) {
        this.resourceService.getProspect(saleId).subscribe((response) => {
            if (response.redirectUrl) {
                window.open(response.redirectUrl, "_blank");
            } else if (response.reportData) {
                const binaryString = window.atob(response.reportData);
                const bytes = new Uint8Array(binaryString.length);
                const uInt8Array = bytes.map((_, i) => binaryString.charCodeAt(i));
                const blob = new Blob([uInt8Array], { type: "application/pdf" });
                const newWindow = window.open("", "_blank");
                let url: string = "";

                if (window.webkitURL != null) {
                    url = window.webkitURL.createObjectURL(blob);
                } else {
                    url = URL.createObjectURL(blob);
                }
                newWindow.location.href = url;
            }
        });
    }
}

enum SaleStatus {
    sold = 0,
    forSale = 1,
    withdrawn = 2,
}
